import { render, staticRenderFns } from "./UserReply.vue?vue&type=template&id=dfef939c&scoped=true&"
import script from "./UserReply.vue?vue&type=script&lang=js&"
export * from "./UserReply.vue?vue&type=script&lang=js&"
import style0 from "./UserReply.vue?vue&type=style&index=0&id=dfef939c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfef939c",
  null
  
)

export default component.exports